import dynamic from 'next/dynamic';
import { OTPGenerationProps } from './OTPGeneration.types';

export const OTPGeneration = dynamic<OTPGenerationProps>(() =>
  import('./OTPGeneration').then(module => module.OTPGeneration)
);
